import {
  getFilters,
  updateFilters,
  facetToRender,
  getSeriesFilterString,
  getcategoryFilter,
  getFilterParse,
} from "./filters";
import { fetchRetailRecommendations } from "./g-utils";

if (performance.navigation.type != performance.navigation.TYPE_RELOAD) {
  const paramsQuery = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

  let queryString = "";
  if (paramsQuery) {
    queryString = paramsQuery.q;
  }

  resetOldFilters();
  const firstEntryFilters = {
    filterCheckedItems: [],
    queryString: [],
    filterPrice: {},
  };

  if (!queryString?.includes("opusID") && queryString) {
    firstEntryFilters.filterCheckedItems.push("filter.p.availability-IN_STOCK");
    firstEntryFilters.queryString.push('(availability: ANY("IN_STOCK"))');
  }

  sessionStorage.setItem("defaultFilters", JSON.stringify(firstEntryFilters));
}

const viewModeEl = document.querySelector('.js-view-mode');
const collectionItemsEl = document.querySelector(".js-collection-items");
const filtersEl = document.querySelector(".js-filters");

document.addEventListener("search:page", (e) => {
  collectionItemsEl.setAttribute('aria-busy', true);
  filtersEl?.setAttribute('aria-busy', true);
  viewModeEl.setAttribute("aria-disabled", true);

  _loadSearchPage(e.detail);
});

document.addEventListener("search:pageUpdateLayoutMode", (e) => {
  sessionStorage.setItem("newLayoutMode", `${e.detail.layoutMode}`);
});

document.addEventListener("search:pageUpdateSorting", (e) => {
  sessionStorage.setItem("sortPageMode", `${e.detail.sortValue}`);
  sessionStorage.setItem("currentPage", "");
});

document.addEventListener("search:pageUpdateProductsPerPage", (e) => {
  sessionStorage.setItem("productsPerPage", `${e.detail.productsPerPage}`);
  sessionStorage.setItem("currentPage", "");
});

document.addEventListener("search:pageUpdatePagination", (e) => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  sessionStorage.setItem("currentPage", e.detail.target.dataset.page);
});



export let options = {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: "",
};

const facetsPreset = [
  { facetKey: { key: "brands", returnMinMax: true }, limit: 300 },
  {
    facetKey: {
      key: "price",
      returnMinMax: true,
      intervals: [{ minimum: 0, maximum: 99999999999999 }],
    },
  },
  { facetKey: { key: "attributes.series" }, limit: 300 },
  { facetKey: { key: "categories" }, limit: 300 },
  { facetKey: { key: "attributes.format" }, limit: 300 },
  { facetKey: { key: "attributes.language" }, limit: 300 },
  { facetKey: { key: "attributes.publisher" }, limit: 300 },
  { facetKey: { key: "availability" } },
];


// set layout for product displaing on search page
function getNewLayoutMode(element) {
  let layoutMode = localStorage.getItem("collectionLayout");
  if(!layoutMode) {
    layoutMode = element.settings.defaultLayout;
    localStorage.setItem("collectionLayout", layoutMode);
  }

  return layoutMode;
}



// get number of products per page
function getDefaultProductsPerPage(query, element) {
  let defaultProductsPerPage;

  if (sessionStorage.getItem("productsPerPage")) {
    defaultProductsPerPage = sessionStorage.getItem("productsPerPage");
  } else {
    defaultProductsPerPage = element.settings.defaultProductsPerPage;
    sessionStorage.setItem("productsPerPage", defaultProductsPerPage);
  }

  query.branchCountResultsSearch = defaultProductsPerPage;

  return defaultProductsPerPage;
}

// get current page from general search
function getCurrentPage(query, defaultProductsPerPage) {
  let currentPage;

  if (sessionStorage.getItem("currentPage")) {
    currentPage = sessionStorage.getItem("currentPage");
  } else {
    currentPage = 1;
    sessionStorage.setItem("currentPage", currentPage);
  }

  if (currentPage > 1) {
    query.offsetSearch = (currentPage - 1) * defaultProductsPerPage;
  }

  return currentPage;
}

// define type of sorting on the search page
function getSortPageMode(element, query) {
  let sortPageMode;

  if (sessionStorage.getItem("sortPageMode")) {
    sortPageMode = sessionStorage.getItem("sortPageMode");
  } else {
    sortPageMode = element.sortBy
      ? element.sortBy
      : "relevance";
    sessionStorage.setItem("sortPageMode", `${sortPageMode}`);
  }

  if (sortPageMode == "price-ascending") {
    query.searchOrderBy = "price";
  } else if (sortPageMode == "price-descending") {
    query.searchOrderBy = "price desc";
  }

  return sortPageMode;
}

// reset applyed filters
function resetOldFilters() {
  document.dispatchEvent(
    new CustomEvent("search:resetsessionStorageVariablesFilters")
  );
}

async function getSearchResult(
  element,
  filterParse,
  defaultProductsPerPage,
  currentPage,
  sortPageMode,
  url,
  query,
  paramsQuerySearchText,
  searchSectionId,
  newLayoutMode,
  paramsQuery,
  categoryFilter,
  seriesFilterString,
  data,
  trackAuthorView
) {

 
  let searchProductVariants = [];
  const productDetails = []

  const productsResults = data.results;
  const attributionToken = data.attributionToken;
  sessionStorage.setItem("attributionToken", `${attributionToken}`);
  const resultsProductsCount = data.totalSize || 0;
  if (productsResults) {
    // find variant
    productsResults.forEach((searchProduct) => {
      if (searchProduct.product.title) {
        searchProductVariants.push(searchProduct.product);
        productDetails.push({
          product: {
            id: `${searchProduct.id}`,
          },
        });
      }
    });


    window.dataLayer.push({
      cloud_retail: "",
    });

    const filterActivePriceMinValue = filterParse?.filterPrice?.minValue;
    const filterPriceMin = filterParse?.filterPrice?.min;
    const filterActivePriceMaxValue = filterParse?.filterPrice?.maxValue;
    const filterPriceMax = filterParse?.filterPrice?.max;

    const countPagination = Math.ceil(
      resultsProductsCount / +defaultProductsPerPage
    );

    let pagination = document.querySelector("pagination-search");

    if (!pagination) {
      pagination = document.createElement("pagination-search");
      pagination.setAttribute("page", currentPage);
      document.querySelector(".js-pagination").appendChild(pagination);
    }

    pagination.updatePagination(
      data.totalSize,
      parseInt(currentPage),
      defaultProductsPerPage
    );

    const promotionalCardsByIndex = {};
    document.querySelectorAll('[data-search-promotion-card-position]')
      .forEach(card => {
        promotionalCardsByIndex[card.dataset.searchPromotionCardPosition] = card
      });

    const trackAuthorViewList = []

    const productTemplateItems = searchProductVariants
      .map((product, index) => {
        let cardTemplate = promotionalCardsByIndex[index + 1]?.innerHTML || '';
        return cardTemplate + getTemplateProductResultItem(
          product,
          productsResults[index].id,
          newLayoutMode,
          element,
          trackAuthorViewList,
          trackAuthorView
        );
      })
      .join("");

    if (trackAuthorView) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'view_author_ta',
        ecommerce: {
          items: trackAuthorViewList
        }
      });
    }

    const headingEl = element.querySelector('.js-heading')
    const booksCountEl = headingEl?.querySelector('.js-books-count');
    if (booksCountEl) {
      booksCountEl.innerHTML = data.totalSize;
      headingEl.setAttribute('aria-busy', false);
    }
    collectionItemsEl.innerHTML =
      productTemplateItems;
    collectionItemsEl.setAttribute("aria-busy", false);
    filtersEl?.setAttribute('aria-busy', false);


    element.querySelector(
      "[data-dsk-results-count]"
    ).innerHTML = `Affiche ${currentPage == 1
      ? currentPage
      : (currentPage - 1) * defaultProductsPerPage + 1
    } - 
        ${currentPage == countPagination
        ? resultsProductsCount
        : currentPage * defaultProductsPerPage
      } 
        de ${resultsProductsCount} résultats`;

    if (element.querySelector("[data-mob-results-count]")) {
      element.querySelector(
        "[data-mob-results-count]"
      ).innerHTML = `${resultsProductsCount} résultats`;
    }
    element.querySelector(".js-showing-count").value = defaultProductsPerPage;
    element.querySelector(".js-sort-by").value = sortPageMode;

    const customeElActiveFilters =
      element.querySelector(".js-active-filters");

    if(customeElActiveFilters) {
      if (filterParse?.queryString.length > 0) {
        const activeFilters = filterParse.filterCheckedItems;

        activeFilters.forEach((activeFilter) => {
          if (activeFilter.includes("availability")) {
            return;
          }

          let checkActiveFilter = "";
          if (activeFilter.indexOf('"') > -1) {
            checkActiveFilter = customeElActiveFilters.querySelector(
              `active-filter-item label[for='` + activeFilter + `']`
            );
          } else if (activeFilter.indexOf("'") > -1) {
            checkActiveFilter = customeElActiveFilters.querySelector(
              `active-filter-item label[for="` + activeFilter + `"]`
            );
          } else {
            checkActiveFilter = customeElActiveFilters.querySelector(
              `active-filter-item label[for='` + activeFilter + `']`
            );
          }

          if (!checkActiveFilter) {
            const activeFilterItem = document.createElement("active-filter-item");
            activeFilterItem.activeFilter({ type: "filter", activeFilter });
            customeElActiveFilters.appendChild(activeFilterItem);
          }
        });

        Array.from(
          customeElActiveFilters.querySelectorAll(`active-filter-item label`)
        ).forEach((el) => {
          if (el.getAttribute("for") && !activeFilters.includes(el.getAttribute("for"))) {
            el.closest("active-filter-item").remove();
          }
        });

        if (
            !isNaN(filterActivePriceMinValue) && 
            !isNaN(filterActivePriceMaxValue) &&
            (
              filterPriceMin !== filterActivePriceMinValue || 
              filterPriceMax !== filterActivePriceMaxValue
            )
          ) {
          const activeFilterItemPrice =
            document.createElement("active-filter-item");
          activeFilterItemPrice.setAttribute("data-action", "clear-filter-price");
          activeFilterItemPrice.activeFilter({
            type: "price",
            activeFilter: `${filterActivePriceMinValue} € - ${filterActivePriceMaxValue} €`,
          });
          customeElActiveFilters.appendChild(activeFilterItemPrice);
        } else {
          const activePriceFilterItem = customeElActiveFilters.querySelector("active-filter-item[data-action='clear-filter-price']")
          activePriceFilterItem?.remove();
        }

        let countFilters = 0;
        if (categoryFilter?.categoryFilterActive.length > 0) {
          categoryFilter?.categoryFilterActive?.forEach((categoryActiveName) => {
            const activeFilterItemCategory =
              document.createElement("active-filter-item");
            activeFilterItemCategory.setAttribute(
              "data-action",
              "clear-filter-category"
            );
            activeFilterItemCategory.activeFilter({
              type: "category",
              activeFilter: categoryActiveName,
            });
            customeElActiveFilters.appendChild(activeFilterItemCategory);
            countFilters += 1;
          });
        }

        if (seriesFilterString?.filterCheckedItems.length > 0) {
          seriesFilterString?.filterCheckedItems?.forEach((seriesActiveName) => {
            const activeFilterItemSeries =
              document.createElement("active-filter-item");
            activeFilterItemSeries.setAttribute(
              "data-action",
              "clear-filter-series"
            );
            activeFilterItemSeries.activeFilter({
              type: "series",
              activeFilter: seriesActiveName,
            });
            customeElActiveFilters.appendChild(activeFilterItemSeries);
          });
        }

        if (filterParse.filterCheckedItems.length > 0) {
          countFilters += filterParse.filterCheckedItems.includes(
            "filter.p.availability-IN_STOCK"
          )
            ? filterParse.filterCheckedItems.length - 1
            : filterParse.filterCheckedItems.length;
        }

        if(
            !isNaN(filterActivePriceMinValue) && 
            !isNaN(filterActivePriceMaxValue) &&
            (
              filterPriceMin !== filterActivePriceMinValue || 
              filterPriceMax !== filterActivePriceMaxValue
            )
          ) {
          countFilters += 1;
          const priceRanges = element.querySelectorAll("price-range");
          priceRanges.forEach((priceRange) => {
            priceRange.minValue = filterActivePriceMinValue;
            priceRange.maxValue = filterActivePriceMaxValue;
          });
        }

        if (countFilters > 0) {
          element
            .querySelector(".collection__filter-icon")
            ?.classList.add("collection__filter-icon--active");
          element.querySelector(
            "[data-mobile-filter-count]"
          ).innerHTML = `&nbsp;(${countFilters})`;
        }
      } else {
        customeElActiveFilters
          .querySelectorAll("active-filter-item")
          .forEach((el) => {
            el.remove();
          });
        element.querySelector("[data-mobile-filter-count]").innerHTML = "";
        element
          .querySelector(".collection__filter-icon")
          ?.classList.remove("collection__filter-icon--active");
      }
    }

    element
      .querySelector(`.search-result`)
      .classList.remove("jc-hidden");
    element
      .querySelector(`.empty-search-result`)
      .classList.add("jc-hidden");
  }

  document.dispatchEvent(new CustomEvent("search:loaded"));

  const ga_search = {
    event: "ga_search",
    cloud_retail: {
      eventType: "search",
      visitorId: localStorage.getItem("visitorId"),
      orderBy: `${query?.searchOrderBy ?? ""}`,
      offset: +query?.offsetSearch || 0,
      searchQuery: `${paramsQuerySearchText}`,
      filter: `${filterParse?.queryString.join(" AND ") ?? ""}`,
      productDetails: productDetails,
      attributionToken: sessionStorage.getItem("attributionToken") || null,
      userInfo: {
        userId: `${window.userId}`,
      }
    },
    result_count: resultsProductsCount
  };

  window.dataLayer.push(ga_search);
}

// apply clicked autocomplete filter from header search input to the search page
function setAutocompleteFilter(paramsQuery, redirectKey) {
  const paramsQuerySearchText = paramsQuery.q;
  const findCurrentAutocompleteType = facetToRender.find(
    (facet) => facet.autocomplete_key == redirectKey
  );

  if (redirectKey === "category") {
    const categoryFilter = {
      categoryFilterString: "",
      categoryFilterActive: [],
    };

    categoryFilter.categoryFilterString = `categories: ANY("${paramsQuerySearchText}")`;
    categoryFilter.categoryFilterActive.push(paramsQuerySearchText);

    sessionStorage.setItem("categoryFilter", JSON.stringify(categoryFilter));
  } else if (redirectKey === "series") {
    const sagaFilterString = `(attributes.series: ANY("${paramsQuerySearchText}"))`;
    const seriesObj = {
      queryString: "",
      filterCheckedItems: [],
    };
    seriesObj.queryString = sagaFilterString;
    seriesObj.filterCheckedItems.push(paramsQuerySearchText);

    sessionStorage.setItem("seriesFilterString", JSON.stringify(seriesObj));
  } else if (findCurrentAutocompleteType) {
    const filterParse = {
      filterCheckedItems: [],
      queryString: [],
      filterPrice: {},
    };

    filterParse.filterCheckedItems.push(
      `filter.p.${findCurrentAutocompleteType.facet_key}-${paramsQuerySearchText}`
    );
    filterParse.filterCheckedItems.push("filter.p.availability-IN_STOCK");
    filterParse.queryString.push(
      `(${findCurrentAutocompleteType.facet_key}: ANY("${paramsQuerySearchText}"))`
    );
    filterParse.queryString.push('(availability: ANY("IN_STOCK"))');

    sessionStorage.setItem("defaultFilters", JSON.stringify(filterParse));
  }

  sessionStorage.removeItem("redirectKey");
}

async function _loadSearchPage(detail) {
  const element = detail.element;
  const searchSectionId = element.dataset.sectionId;
  const redirectKey = sessionStorage.getItem("redirectKey") || null;
  let trackAuthorView = false
  const urlParams = new URLSearchParams(document.location.search);
  if (urlParams.get("author-page") === "true") {
    trackAuthorView = true
  }
  const newLayoutMode = getNewLayoutMode(element);
  const paramsQuery = window.location.href.includes("favourite_product")
    ? { q: element.dataset.favouriteProductIds }
    : new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

  const paramsQuerySearchText = window.location.href.includes(
    "favourite_product"
  )
    ? element.dataset.favouriteProductIds
    : paramsQuery.q.includes("opusID")
      ? paramsQuery.q.split(":")[1]
      : paramsQuery.q;
  // store query parameters from URL

  setAutocompleteFilter(paramsQuery, redirectKey);

  const seriesFilterString = getSeriesFilterString();
  const categoryFilter = getcategoryFilter();
  const query = {
    query: paramsQuerySearchText,
    rout: "search",
    visitorId: localStorage.getItem("visitorId"),
    branchSearch: "0",
    userId: window.userId
  };
  const filterParse = getFilterParse(
    query,
    categoryFilter,
    seriesFilterString,
    paramsQuery
  );

  const defaultProductsPerPage = getDefaultProductsPerPage(query, element);
  const currentPage = getCurrentPage(query, defaultProductsPerPage);
  const sortPageMode = getSortPageMode(element, query);

  const url = window.Shopify.routes.root + "apps/search";
  query.facetKeysSearch = facetsPreset;
  options.body = JSON.stringify(query);

  const collectionFiltersEl = element.querySelector("#collection-filters");

  try {
    const response = await fetch(url, options);
    let data = response;
    if (data.ok) {
      data = await data.json();
    } else {
      data = await data.text();
    }

    if (!document.querySelector("#filter-p-availability") && collectionFiltersEl) {
      const activeFiltersItems = filterParse?.filterCheckedItems ?? [];

      for (const facet in facetToRender) {
        // Create a new instance of ProductItem
        if (facetToRender[facet].facet_key == "availability") {
          const filterBlock = document.createElement("filter-block");
          filterBlock.setParentBlockFilterText = {
            title: facetToRender[facet].facet_title,
            type: facetToRender[facet].facet_key,
            showSearch: facetToRender[facet].show_search,
          };

          //render availability

          filterBlock.setChildItemFilterAvailability = {
            title: facetToRender[facet].facet_title,
            data: [{ value: "IN_STOCK" }],
            type: facetToRender[facet].facet_key,
            checkedItems: activeFiltersItems,
          };

          filterBlock.setAttribute("id", facetToRender[facet].facet_key);

          // Append the new product item to the container
          document.querySelector(".js-active-filters").after(filterBlock);
        }
      }
    }

    if (data.results) {
      if(collectionFiltersEl) {
        await getFilters(
          element,
          url,
          filterParse,
          paramsQuery,
          paramsQuerySearchText,
          data
        );
      }
      
      getSearchResult(
        element,
        filterParse,
        defaultProductsPerPage,
        currentPage,
        sortPageMode,
        url,
        query,
        paramsQuerySearchText,
        searchSectionId,
        newLayoutMode,
        paramsQuery,
        categoryFilter,
        seriesFilterString,
        data,
        trackAuthorView
      );

      if(collectionFiltersEl) {
        updateFilters(url, filterParse, query, data);
      }
    } else {
      fetchData(url, options, element, paramsQuery, filterParse, query);
      const ga_search = {
        event: "ga_search",
        cloud_retail: {
          eventType: "search",
          visitorId: localStorage.getItem("visitorId"),
          orderBy: `${query?.searchOrderBy ?? ""}`,
          offset: +query?.offsetSearch || 0,
          searchQuery: `${paramsQuerySearchText}`,
          filter: `${filterParse?.queryString.join(" AND ") ?? ""}`,
          productDetails: [],
          attributionToken: sessionStorage.getItem("attributionToken") || null,
          userInfo: {
            userId: `${window.userId}`,
          }
        },
        result_count: 0
      };
      window.dataLayer.push(ga_search);
    }
  } catch (error) {
    console.error(error);
    element
      .querySelector(`.search-result`)
      .classList.add("jc-hidden");
    element
      .querySelector(`.jc-main-search-container .layout__section--secondary`)
      .classList.add("jc-hidden");
    element
      .querySelector(`.empty-search-result`)
      .classList.remove("jc-hidden");
    element.querySelector(
      `.empty-search-result .empty-state__description span`
    ).innerHTML = paramsQuery.q.trim();
  }

  viewModeEl.setAttribute("aria-disabled", false);

  collectionItemsEl.setAttribute('aria-busy', false);
  filtersEl?.setAttribute('aria-busy', false);
}

// Main function to fetch data and handle the result
async function fetchData(url, options, element, paramsQuery, filterParse, query) {
  try {
    // Filter out 'IN_STOCK' items from queryString
    filterParse.queryString = filterParse.queryString.filter(
      (item) => !item.includes("IN_STOCK")
    );
    query.filterSearch = filterParse.queryString.join(" AND ");
    options.body = JSON.stringify(query);

    // Fetch data from server
    const response = await fetch(url, options);
    const data = response.ok ? await response.json() : await response.text();

    // Handle search results in the DOM
    handleSearchResult(element, data, paramsQuery);

    // If results exist, fetch recommendations
    if (data.results) {
      await fetchRecommendations(data.results[0].id, element);
    } else {
      await processRecommendations({ result: [] }, element);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    handleEmptySearchResult(element, paramsQuery.q.trim());
  }
}

// Handle updating the DOM based on the search results
function handleSearchResult(element, data, paramsQuery) {
  const {
    cardElement,
    secondarySection,
    inStockEmptyResult,
    emptyResult,
    recommendation,
  } = getDomElements(element);

  document.querySelector('search-section').style.backgroundColor = '#FCFCFD'

  // Update DOM elements based on whether there are results
  if (data.results) {
    hideElements([cardElement, secondarySection]);
    showElement(inStockEmptyResult);
    showElement(recommendation);
    inStockEmptyResult.querySelector(
      ".empty-state__description span"
    ).textContent = paramsQuery.q.trim();
  } else {
    hideElements([cardElement, secondarySection]);
    showElement(emptyResult);
    showElement(recommendation);
    emptyResult.querySelector(".empty-state__description span").textContent =
      paramsQuery.q.trim();
  }
}

// Handle when no search results are found (Error case)
function handleEmptySearchResult(element, queryText) {
  const { cardElement, secondarySection, emptyResult } = getDomElements(element);
  hideElements([cardElement, secondarySection]);
  showElement(emptyResult);
  emptyResult.querySelector(".empty-state__description span").textContent =
    queryText;
}

// Function to fetch product recommendations
async function fetchRecommendations(productId, element) {

  try {
    const result = await fetchRetailRecommendations({
      type: "no_stock",
      products: [{ primaryProductId: productId }],
      pageSize: 20,
    })
    // Process recommendations and update the DOM
    await processRecommendations(result, element);
  } catch (error) {
    console.error("Error fetching recommendations:", error);
  }
}

// Helper function to update the DOM with fetched recommendations
async function processRecommendations(result, element) {
  const ajaxRecommendationSection = document.querySelector(
    "[data-recommendation] g-carousel"
  );
  if (!ajaxRecommendationSection) return;

  const sectionId = ajaxRecommendationSection.dataset.sectionId;
  const productHandles = result.result.products
    .map((product) => product?.isbn)
    .join(",");
  const recommendationUrl = `/search/?sections=${sectionId}${productHandles ? `&product_ids=${productHandles}` : ""
    }`;

  try {
    const response = await fetch(recommendationUrl);
    const res = await response.json();
    const keys = Object.keys(res);

    if (keys.length > 0) {
      const recommendationTemplateText = res[keys[0]];
      const recommendationTemplate = new DOMParser()
        .parseFromString(recommendationTemplateText, "text/html")
        .querySelector("[data-recommendation] .splide__list").innerHTML;

      ajaxRecommendationSection.splideList.innerHTML = recommendationTemplate;
      ajaxRecommendationSection.refresh();
    }
  } catch (error) {
    console.error("Error processing recommendations:", error);
  }
}

// Utility functions for common DOM manipulations
function getDomElements(element) {
  return {
    cardElement: element.querySelector(
      ".search-result"
    ),
    secondarySection: element.querySelector(
      "#collection-filters"
    ),
    inStockEmptyResult: element.querySelector(
      ".empty-search-result-in-stock"
    ),
    emptyResult: element.querySelector(".empty-search-result"),
    recommendation: document.querySelector("[data-recommendation]"),
  };
}

function hideElements(elements) {
  elements.forEach((element) => element.classList.add("jc-hidden"));
}

function showElement(element) {
  if (element) {
    element.classList.remove("jc-hidden");
  }
}


function formatDate(date) {
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];
  const monthName = months[monthIndex];

  const paddedDay = day.toString().padStart(2, "0");

  return `${paddedDay} ${monthName} ${year}`;
}

const favouriteProductBtnTemplate = document.querySelector("#favourite-product-btn-template").innerHTML;
const productItemTemplate = document.querySelector("#product-item-template").innerHTML;

function getTemplateProductResultItem(product, barcode, newLayoutMode, element, trackAuthorViewList, trackAuthorView) {
  const getSortedVariants = (variants) =>
    variants.edges.sort(
      (prev, next) =>
        Number.parseFloat(prev.node.price) - Number.parseFloat(next.node.price)
    );
  
  let firstAvailableVariant = "";
  
  let [L1_main_category, L2_main_category, pricing_group, pricing_stage] = [null, null, null, null];
  if (product.shopifyRespone) {
    const sortedVariants = getSortedVariants(product.shopifyRespone.variants);
    firstAvailableVariant =
      sortedVariants.find((variant) => variant.node.availableForSale)?.node ||
      sortedVariants.find((variant) => !variant.node.availableForSale)?.node ||
      "";
    L1_main_category = product.shopifyRespone.L1_main_category?.value;
    L2_main_category = product.shopifyRespone.L2_main_category?.value;
    pricing_group = product.shopifyRespone.pricing_group?.value;
    pricing_stage = product.shopifyRespone.pricing_stage?.value;
  }

  const collections = product?.shopifyRespone.collections?.edges.map(item => item.node) || [];
  const collection = collections[0] || null;
  const collectionId = collection?.id.split('/').pop();

  const productShopifyId = product.attributes.shopifyProductId
    ? +product.attributes.shopifyProductId.text[0].split("/").pop()
    : "";
  const favouriteProducts = window.favouriteProducts || null;

  const checkFavouriteProduct = favouriteProducts?.includes(productShopifyId);
  const productURL = product.uri;
  const imgSrc = product?.images?.[0]?.uri || "";
  let hideImage = imgSrc ? false : true;
  const title = product.title;
  const author = product.attributes?.author?.text[0];
  const price = firstAvailableVariant?.price ?? product.priceInfo.price;
  const compareAtPrice = firstAvailableVariant?.compareAtPrice ?? product.priceInfo.originalPrice;
  const available = firstAvailableVariant?.availableForSale ?? false;
  const mainSearch = element.settings.mainSearch;
  const firstAvailableVariantID = firstAvailableVariant?.id.split("/").pop() ?? "";
  const format = product.attributes.format?.text?.[0];
  const publisher = product.attributes.publisher?.text?.[0];
  const publicationDate = product.attributes.publicationDate?.text
    ? new Date(product.attributes.publicationDate?.text)
    : "";
  const publicationDateStr = publicationDate ? formatDate(publicationDate) : "";

  if (trackAuthorView) {
    trackAuthorViewList.push({
      item_id: productShopifyId,
      item_variant: firstAvailableVariant?.title,
      item_variant_id: firstAvailableVariantID,
      item_variant_title: firstAvailableVariant?.title,
      item_product_id: productShopifyId,
      item_product_title: title,
      item_name: title,
      discount: compareAtPrice ? Number((compareAtPrice - price).toFixed(2)) : 0,
      price: +price,
      item_brand: author,
      item_category: "",
      item_list_id: collectionId || null,
      item_list_name: collection?.title || null,
      sku: firstAvailableVariant?.sku
    })
  }

  const favouriteProductEl = favouriteProductBtnTemplate
      .replaceAll("[[productShopifyId]]", productShopifyId)
      .replaceAll("[[favouriteProductBtnClass]]", checkFavouriteProduct ? "jc-fill-electricViolet jc-text-electricViolet" : "")
      .replaceAll("[[item_id]]", firstAvailableVariantID)
      .replaceAll("[[item_variant]]", firstAvailableVariant?.title ?? "")
      .replaceAll("[[item_variant_id]]", firstAvailableVariantID)
      .replaceAll("[[item_variant_title]]", firstAvailableVariant?.title ?? "")
      .replaceAll("[[item_product_id]]", productShopifyId)
      .replaceAll("[[item_product_title]]", title)
      .replaceAll("[[item_name]]", title)
      .replaceAll("[[discount]]", compareAtPrice ? Number((compareAtPrice - price).toFixed(2)) : 0)
      .replaceAll("[[price]]", price)
      .replaceAll("[[item_brand]]", author)
      .replaceAll("[[item_list_id]]", collectionId || null)
      .replaceAll("[[item_list_name]]", collection?.title ? `"${collection?.title}"` : null)
    ;

  const layoutMode =
    newLayoutMode == "list"
      ? "horizontal"
      : "vertical";

  const infoEl = [format, publisher, publicationDateStr]
  .filter(Boolean)
  .map(info => `<span>${info}</span>`)
  .join("<span class='jc-leading-4'>-</span>");

  const variantsJson = {
    variants: product.shopifyRespone?.variants.edges.map(item => item.node.id.split('/').pop()) || []
  };

  const productItemEl = productItemTemplate
    .replaceAll("[[!available]]", !available)
    .replaceAll("[[variantsJson]]", JSON.stringify(variantsJson).replace(/"/g, "&quot;"))
    .replaceAll("[[layoutMode]]", layoutMode)
    .replaceAll("[[firstAvailableVariantID]]", firstAvailableVariantID)
    .replaceAll("[[favouriteProductEl]]", favouriteProductEl)
    .replaceAll("[[productURL]]", productURL)
    .replaceAll("[[imgSrc]]", imgSrc)
    .replaceAll("[[title]]", title)
    .replaceAll("[[hideImage]]", hideImage)
    .replaceAll("[[!hideImage]]", !hideImage)
    .replaceAll("[[author]]", author)
    .replaceAll("[[infoEl]]", infoEl)
    .replaceAll("[[price]]", price ? window.jollyFunctions.formatMoney(price) : "")
    .replaceAll("[[priceValue]]", price ?? "")
    .replaceAll("[[compareAtPrice]]", compareAtPrice ? window.jollyFunctions.formatMoney(compareAtPrice) : "")
    .replaceAll("[[hideCompareAtPrice]]", compareAtPrice <= price)
    .replaceAll("[[hideSecondaryAtcButton]]", mainSearch)
    .replaceAll("[[categories]]", "[" + collections.map(collection => `&quot;${collection.title}&quot;`).join(", ") + "]")
    .replaceAll("[[L1_main_category]]", L1_main_category ? `&quot;${L1_main_category}&quot;` : null)
    .replaceAll("[[L2_main_category]]", L2_main_category ? `&quot;${L2_main_category}&quot;` : null)
    .replaceAll("[[pricing_group]]", pricing_group ? `&quot;${pricing_group}&quot;` : null)
    .replaceAll("[[pricing_stage]]", pricing_stage ? `&quot;${pricing_stage}&quot;` : null)
    .replaceAll("[[productShopifyId]]", productShopifyId)
    .replaceAll("[[barcode]]", barcode || "")
  ;

  return productItemEl;
}

class SearchPagination extends HTMLElement {
  static observedAttributes = ["page"];

  constructor() {
    // Always call super first in constructor
    super();
  }

  connectedCallback() {
    this.innerHTML = document.getElementById( 
      "search-page-pagination"
    ).innerHTML;
  }

  updatePagination(data, currentPage, defaultProductsPerPage) {
    this.data = data;
    this.defaultProductsPerPage = defaultProductsPerPage;
    const resultsProductsCount = data;
    const countPagination = Math.ceil(
      resultsProductsCount / +defaultProductsPerPage
    );
    const nextPageButton = this.querySelector(".pagination__next");
    const prevPageButton = this.querySelector(".pagination__prev");
    const paginationCount = this.querySelector(".js-pagination__count-page");
    const paginationCurrentPage = this.querySelector(
      ".js-pagination__current-page"
    );

    prevPageButton?.setAttribute('aria-disabled', currentPage == 1);
    nextPageButton?.setAttribute('aria-disabled', currentPage == countPagination);

    if (paginationCount) {
      paginationCount.innerHTML = countPagination;
    }
    if (paginationCurrentPage) {
      paginationCurrentPage.innerHTML = currentPage;
    }

    nextPageButton?.setAttribute("data-page", currentPage + 1);
    prevPageButton?.setAttribute("data-page", currentPage - 1);

    if (countPagination == 1) {
      this.closest(".js-pagination")?.classList.add("jc-hidden");
    } else {
      this.closest(".js-pagination")?.classList.remove("jc-hidden");
    }

    this.querySelectorAll("[data-pagination-item]").forEach((el, index) => {
      el.classList.remove("is-active", "jc-pointer-event-none");
      if (el.classList.contains("js-first-page")) {
        el.innerHTML = 1;
        el.setAttribute("data-page", 1);
      } else if (el.classList.contains("js-last-page")) {
        el.innerHTML = countPagination;
        el.setAttribute("data-page", countPagination);
      } else {
        let pageShift = currentPage - 3;
        el.innerHTML = pageShift + index;
        el.setAttribute("data-page", pageShift + index);
        el.classList.remove("jc-hidden");
        if (pageShift + index < 2 || pageShift + index > countPagination - 1) {
          el.classList.add("jc-hidden");
        }
        if (pageShift <= 1) {
          this.querySelector(".js-first-spacing").classList.add("jc-hidden");
        } else {
          this.querySelector(".js-first-spacing").classList.remove("jc-hidden");
        }
        if (pageShift + 6 >= countPagination) {
          this.querySelector(".js-last-spacing").classList.add("jc-hidden");
        } else {
          this.querySelector(".js-last-spacing").classList.remove("jc-hidden");
        }
      }
    });

    this.querySelectorAll(
      `[data-page='${currentPage}']:not(.jc-hidden)`
    ).forEach((el) => {
      el.classList.add("is-active", "jc-pointer-event-none");
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.updatePagination(this.data, newValue, this.defaultProductsPerPage);
  }
}

customElements.define("pagination-search", SearchPagination);
